import { observer } from "mobx-react-lite"

import type { ZapStore } from "@/domains/minimal-pools-zap/zap-store"

interface ZapExecutionFailedProps {
  store: ZapStore
}

export const ZapExecutionFailed = observer(({ store }: ZapExecutionFailedProps) => {
  if (!store.pool) return null

  return (
    <div className="text-t100 border-p400-light bg-p400 flex h-40 items-center justify-center rounded-lg border px-4 py-3 text-center">
      <div>
        <p className="text-t100 mb-1 text-xl">Zap failed</p>
        <p className="mb-2 text-4xl">{store.executionError ? store.executionError : "Unknown error"}</p>
        <p className="text-t200 mb-1">Please try again.</p>
      </div>
    </div>
  )
})
